/**
 * @generated SignedSource<<ed34fb21fd829586e0b75d96d2a640fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BrandInputPartial = {
  appsflyerDevKey?: string | null;
  discourseContactEmail?: string | null;
  email?: string | null;
  emarsysApiClientId?: string | null;
  emarsysApiClientSecret?: string | null;
  facebookAppId?: string | null;
  facebookAppSecret?: string | null;
  facebookClientToken?: string | null;
  facebookConfig?: FacebookClientTokenInput | null;
  facebookLoginEnabled?: boolean | null;
  googleIosClientId?: string | null;
  googleLoginEnabled?: boolean | null;
  googleWebClientId?: string | null;
  gorgiasId?: string | null;
  id?: string | null;
  klaviyoApiToken?: string | null;
  kustomerApiToken?: string | null;
  ometriaApiToken?: string | null;
  onboardingConfig?: BrandOnboardingConfigInputPartial | null;
  rechargeApiToken?: string | null;
  shopifyConfig?: BrandShopifyConfigInputPartial | null;
  showIosTosAlert?: boolean | null;
};
export type BrandShopifyConfigInputPartial = {
  customerAuthenticationClientId?: string | null;
  id?: string | null;
  isNewCustomerAccountsEnabled?: boolean | null;
  multipassSecret?: string | null;
};
export type BrandOnboardingConfigInputPartial = {
  id?: string | null;
  isAppApproved?: boolean | null;
  isAppListingComplete?: boolean | null;
  isAppSubmitted?: boolean | null;
  isDeveloperAccountSetup?: boolean | null;
  isIncentivesSetup?: boolean | null;
  isKinnAddedToDeveloperAccount?: boolean | null;
  isMarketingSetup?: boolean | null;
  isNotificationsSetup?: boolean | null;
  isThirdPartyIntegrationSetup?: boolean | null;
};
export type FacebookClientTokenInput = {
  appUserId?: string | null;
  id?: string | null;
  token?: string | null;
};
export type useBrandUpdateMutation$variables = {
  input: BrandInputPartial;
};
export type useBrandUpdateMutation$data = {
  readonly updateBrand: {
    readonly appsflyerDevKey: string | null;
    readonly email: string;
    readonly emarsysApiClientId: string | null;
    readonly facebookAppId: string | null;
    readonly facebookClientToken: string | null;
    readonly facebookLoginEnabled: boolean;
    readonly googleIosClientId: string | null;
    readonly googleLoginEnabled: boolean;
    readonly googleWebClientId: string | null;
    readonly gorgiasId: string | null;
    readonly hasEmarsysApiClientSecret: boolean;
    readonly hasFacebookAppSecret: boolean;
    readonly hasKlaviyoApiToken: boolean;
    readonly hasKustomerApiToken: boolean;
    readonly hasOmetriaApiToken: boolean;
    readonly hasRechargeApiToken: boolean;
    readonly id: string;
    readonly shopifyConfig: {
      readonly customerAuthenticationClientId: string | null;
      readonly isNewCustomerAccountsEnabled: boolean;
      readonly multipassEnabled: boolean;
    } | null;
    readonly showIosTosAlert: boolean;
  };
};
export type useBrandUpdateMutation = {
  response: useBrandUpdateMutation$data;
  variables: useBrandUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "multipassEnabled",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isNewCustomerAccountsEnabled",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customerAuthenticationClientId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "facebookAppId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasFacebookAppSecret",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "facebookClientToken",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "facebookLoginEnabled",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "googleIosClientId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "googleWebClientId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "googleLoginEnabled",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gorgiasId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasKlaviyoApiToken",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasKustomerApiToken",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasOmetriaApiToken",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emarsysApiClientId",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasEmarsysApiClientSecret",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasRechargeApiToken",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showIosTosAlert",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appsflyerDevKey",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useBrandUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "updateBrand",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandShopifyConfigType",
            "kind": "LinkedField",
            "name": "shopifyConfig",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useBrandUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "updateBrand",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandShopifyConfigType",
            "kind": "LinkedField",
            "name": "shopifyConfig",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "38ab9b8b0dd5b61beb652f1ddced0cad",
    "id": null,
    "metadata": {},
    "name": "useBrandUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation useBrandUpdateMutation(\n  $input: BrandInputPartial!\n) {\n  updateBrand(input: $input) {\n    id\n    shopifyConfig {\n      multipassEnabled\n      isNewCustomerAccountsEnabled\n      customerAuthenticationClientId\n      id\n    }\n    facebookAppId\n    hasFacebookAppSecret\n    facebookClientToken\n    facebookLoginEnabled\n    googleIosClientId\n    googleWebClientId\n    googleLoginEnabled\n    gorgiasId\n    hasKlaviyoApiToken\n    hasKustomerApiToken\n    hasOmetriaApiToken\n    emarsysApiClientId\n    hasEmarsysApiClientSecret\n    hasRechargeApiToken\n    email\n    showIosTosAlert\n    appsflyerDevKey\n  }\n}\n"
  }
};
})();

(node as any).hash = "b2451e9413703955833ed77a61dc5f65";

export default node;
